import React, { Component } from "react";
import { Table } from "reactstrap";
import AnualidadProyecto from "../../../../types/AnualidadProyecto";
import ResumenClubPeriodoColumns, {
  PeriodoHeaders,
  cantidadColumnas
} from "./ResumenClubPeriodoColumns";
import { MOSTRAR_CONTACT_CENTER } from "./ResumenClubFiltros.form";

interface Props {
  proyecto: AnualidadProyecto;
  filtros: { [key: string]: boolean };
}

const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

const formatMes = (periodoMensual: string): string => {
  const [anio, mes] = periodoMensual.split("-");
  const idx = parseInt(mes, 10) - 1;

  if (idx < 0 || idx > 11) {
    return periodoMensual;
  }

  return `${MESES[idx]} ${anio}`.toUpperCase();
};

export default class ResumenClubTable extends Component<Props> {
  render() {
    const { proyecto, filtros } = this.props;
    const mostrarContactCenter = !!filtros[MOSTRAR_CONTACT_CENTER];
    const colSpan = cantidadColumnas(mostrarContactCenter);
    const periodosVisibles = proyecto.periodosMensuales.filter(
      p => !!filtros[p]
    );

    return (
      <Table bordered responsive size="sm">
        <thead>
          <tr>
            <th rowSpan={2} className="resumen-club-sticky-club">
              Club
            </th>
            <th rowSpan={2} className="resumen-club-sticky-clave">
              Clave
            </th>

            {/* Encabezados "merged" de los periodos marcados */}
            {periodosVisibles.map(periodo => (
              <th
                key={periodo}
                colSpan={colSpan}
                className="resumen-club-month-header"
              >
                {formatMes(periodo)}
              </th>
            ))}
          </tr>
          <tr>
            {/* Encabezados de metas y alcances de los periodos marcados */}
            {periodosVisibles.map(periodo => (
              <PeriodoHeaders
                key={periodo}
                mostrarContactCenter={mostrarContactCenter}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {/* Datos de los clubes */}
          {proyecto.clubes.map(club => (
            <tr key={club.idClub}>
              <td className="resumen-club-sticky-club">{club.nombre}</td>
              <td className="resumen-club-sticky-clave">{club.claveCorta}</td>

              {/* Resumen de alcances de los periodos marcados */}
              {periodosVisibles.map(periodoMes => {
                const data = club.periodos.find(
                  p => p.periodoMensual === periodoMes
                );
                return (
                  <ResumenClubPeriodoColumns
                    key={periodoMes}
                    periodo={data}
                    mostrarContactCenter={mostrarContactCenter}
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}
